import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchVideos } from '../../features/videos/videosSlice';
import Loading from '../ui/Loading';
import Pagination from '../ui/Pagination';
import VideoGridItem from './VideoGridItem';

export default function VideGrid() {
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const { videos, isLoading, isError, error, videosPerPage } = useSelector(
    (state) => state.videos
  );

  const { tags, search, author } = useSelector((state) => state.filter);

  useEffect(() => {
    dispatch(fetchVideos({ tags, search, author }));
  }, [dispatch, tags, search, author]);

  const indexofLastVideo = currentPage * videosPerPage;
  const indexofFastVideo = indexofLastVideo - videosPerPage;
  const currentVideos = videos.slice(indexofFastVideo, indexofLastVideo);

  //change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  // decide what to render
  let content;

  if (isLoading) content = <Loading />;
  if (!isLoading && isError)
    content = <div className="col-span-12">{error}</div>;

  if (!isError && !isLoading && videos?.length === 0) {
    content = <div className="col-span-12">No videos found!</div>;
  }

  if (!isError && !isLoading && videos?.length > 0) {
    content = currentVideos.map((video) => (
      <VideoGridItem key={video.id} video={video} />
    ));
  }

  return (
    <>
      <section className="pt-12">
        <section className="pt-12">
          <div className="grid grid-cols-12 gap-4 max-w-7xl mx-auto px-5 lg:px-0 min-h-[300px]">
            {content}
          </div>
        </section>
      </section>
      <Pagination paginate={paginate} />
    </>
  );
}
